import React from 'react';

interface NoDataFallbackProps {
  show: boolean;
  position?: { right: number; top: number };
}

export default function NoDataFallback({ show, position }: NoDataFallbackProps) {
  if (!show) return null;

  const style = position
    ? { left: 'unset', transform: 'unset', right: `${position.right}px`, top: `${position.top}px` }
    : {};

  return (
    <div className="no-data-fallback" style={style}>
      <h6 className="no-data-fallback__title">collecting initial data</h6>
      <p className="no-data-fallback__text">If no data appears within 48 hours, please reach out to our support team</p>
    </div>
  );
}
